import React, { Component }       from 'react';
import ProfilePlaceholder         from 'assets/icons/profile-placeholder.png';
import moment                     from 'moment';
import { nricOrPassport }         from 'helpers/common.helper';
import { GuaranteeLetterDetails } from './GuaranteeLetterDetails';

export class GuaranteeLetterCards extends Component {
  render() {
    const colorHash   = { 'Initial GL': 'success', 'Rejected': 'primary', 'Opened': 'warning', 'Pending Approval': 'grey', 'Pending Final GL': 'grey', 'Final GL Issued': 'success', 'Expired': 'danger', 'Paid': 'success' };
    const statusHash  = { 'opened': 'Opened', 'pending': 'Pending', 'issued': 'Initial GL', 'rejected': 'Rejected', 'pending_final': 'Pending Final GL', 'issued_final': 'Final GL Issued', expired: 'Expired' };
    const doctype     = { 'outpatient_specialist': 'Outpatient Specialist', 'admission_form': 'Admission Form', 'discharge_form': 'Discharge Form' };
    const today       = moment().format('DD MMM YYYY');

    const patientCards = this.props.items.map((hash, index) => {
      const displayedStatus   = hash.paid ? 'Paid' : statusHash[hash.approval_status];
      const displayedDoctype  = doctype[hash.document_type];
      const color             = colorHash[displayedStatus];
      const checkDate         = moment(hash.request_date).format('DD MMM YYYY');
      const displayedDate     = checkDate === today ? 'Today' : checkDate;
      const viewButton        = <GuaranteeLetterDetails data={ hash } status={ displayedStatus } color={ color } doctype={ displayedDoctype } triggerReload={() => this.props.handleReload() } />;
      const fullName          = [hash.claimant.first_name, hash.claimant.last_name].filter(e => e).join(' ');

      return (
        <tr key={ hash.id } className="patient-card-row bg-white" value={ hash.status }>
          {/* Desktop View */}
            <td valign="top" className={ 'd-none d-lg-table-cell py-6 px-4 border-' + color }>
              <p className="fweight-500 font-size-6 mb-2">{ displayedDate }</p>
              <span className="font-size-4 mb-0">Ref No.: { hash.reference_no }</span>
            </td>

            <td valign="top" className="d-none d-lg-table-cell py-6 pr-4">
              <div className="d-flex align-items-center">
                <img src={ ProfilePlaceholder } alt="profile" className="profile-placeholder mr-4"/>

                <span>
                  <p className="mb-1 font-size-6 fweight-500">{ fullName }</p>
                  <p className="mb-0 font-size-5 fweight-400 text-grey">{ nricOrPassport(hash.claimant.nric) }</p>
                  <a href="derp" className="text-danger d-none">View Profile</a>
                </span>
              </div>
            </td>

            <td valign="top" className={ 'd-none d-lg-table-cell py-6 pr-4' + (hash.insurance?.name ? '' : ' text-center') }>{ hash.insurance?.name || '-' }</td>
            <td valign="top" className={ 'd-none d-lg-table-cell py-6 pr-4' + (displayedDoctype ? '' : ' text-center') }>{ displayedDoctype || '-' }</td>
            <td valign="top" className={ 'd-none d-lg-table-cell py-6 pr-4 text-' + color }><b>{ displayedStatus }</b></td>
            <td valign="top" className="d-none d-lg-table-cell py-6 pr-4">{ viewButton }</td>

          {/* Mobile View */}
            <td colSpan="6" valign="top" className={ 'd-table-cell d-lg-none font-size-7 py-6 pl-6 border-' + color }>
              <div className="d-flex justify-content-between mt-2 mb-2">
                <p className="mb-0 flex-grow-1">
                  <b className="d-inline-block w-em-15 font-size-6">{ displayedDate }</b>
                </p>

                <b className={ 'text-right text-' + color}>{ displayedStatus }</b>
                { viewButton }
              </div>

              <div className="d-flex align-items-center mb-4">
                <img src={ ProfilePlaceholder } alt="profile" className="profile-placeholder mr-4"/>

                <span>
                  <p className="mb-1 font-size-6 fweight-500">{ fullName }</p>
                  <p className="mb-0 font-size-5 fweight-400 text-grey">{ nricOrPassport(hash.claimant.nric) }</p>
                </span>
              </div>

                <div>
                  <span className="d-inline-block w-em-12">Insurance:</span>
                  <b>{ hash.insurance?.name || '-' }</b><br/>
                </div>

              <div className="d-flex align-items-end justify-content-between mb-0 mr-8">
                <div>
                  <span className="d-inline-block w-em-12">Type:</span>
                  <b>{ displayedDoctype || '-' }</b>
                </div>

                <span className="font-size-3 mb-0">Ref No.: { hash.reference_no }</span>
              </div>
            </td>
        </tr>
      )
    });

    const emptyHolder   = <tr className="patient-card-row bg-white">
      <td colSpan="6" className="text-center font-size-7 fweight-500 py-4" style={{ borderRadius: "0.5em" }}>No guarantee letters</td>
    </tr>;

    const displayCards  = patientCards.length > 0 ? patientCards : emptyHolder;

    return (
      <table id="dashboard-cards-table" className="w-100">
        <thead className="d-none d-lg-table-header-group">
          <tr>
            {
              ['Date', 'Patient Profile', 'Insurance', 'Document Type', 'Status', 'Actions'].map((name, index) => {
                const padding = index > 0 ? 'pr-4' : 'px-4';
                return <th key={ 'table-header-' + name } className={ "font-size-7 fweight-500 " + padding }>{ name }</th>
              })
            }
          </tr>
        </thead>

        <tbody>
          { displayCards }
        </tbody>
      </table>
    )
  }
}